import Router from 'navigation/Router';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { lightTheme } from './theme/theme';
import './App.css';
import { Provider } from 'react-redux';
import { store } from 'state-management/store';
import SessionBootstrap from 'components/SessionBootstrap';

function App() {
	return (
		<ThemeProvider theme={lightTheme}>
			<Provider store={store}>
				<CssBaseline />
				<BrowserRouter>
					<SessionBootstrap>
						<Router />
					</SessionBootstrap>
				</BrowserRouter>
			</Provider>
		</ThemeProvider>
	);
}

export default App;
